fragment ComputedDeliverableStatus on ComputedDeliverable {
    _id
    hash
    editableGroupValueIds
    language
    publishedStatus
    status
    users {
        user {
            id
            role {
                _id
                actions
                name
            }
        }
        status
    }
    visibleTo
}
